import { input, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../../app/shared/services/mdb-modal-stub.service';
import { UserPersistenceService } from '../../../core/services/userPersistence.service';
import { IProjDocUpload } from '../../../shared/interfaces/document.Interface';
import { Enums } from '../../../shared/models/enums';
import { ParentChildCommunicationService } from '../../../shared/services/parent-child-communication.service';
import { DesignDocumentCommentComponent } from './design-document-comment.component/design-document-comment.component';

@Component({
    selector: '[ifc-design-documentComment-modal]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './design-documentComment-modal.component.html',
    styleUrls: ['./design-documentComment-modal.component.scss'],
    host: { 'class': 'modal-host-right-panel' },
    standalone: true,
    imports: [DesignDocumentCommentComponent]
})
export class DesignDocumentCommentModalComponent implements OnInit {

    readonly form = input<FormGroup>();   
    heading: string;
    content: string;
    okButton: string = this.userPersistenceService.generalTranslation.Ok;
    cancelButton: string = this.userPersistenceService.generalTranslation.Cancel;
    projDocUpload: IProjDocUpload;

    confirmationStatus = Enums.confirmationStatus;
    action: Subject<any> = new Subject();

    constructor(
        public modalRef: MDBModalRef,
        public userPersistenceService: UserPersistenceService,
        private parentChildCommunicationService: ParentChildCommunicationService 
    ) {        
        
    }

    ngOnInit() { 
    }
  
    onOkClick() {
        this.modalRef.hide();
        this.action.next('ok');
    }

    onCancelClick() {
        this.modalRef.hide();
        this.parentChildCommunicationService.publish('refreshMeasureColor', {});
        this.action.next('Cancel');
    }
}
